var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-field form-field__bool form-field__radio",
      class: _vm.rootClasses
    },
    [
      _vm.label
        ? _c("span", {
            staticClass: "form-field--title-label",
            domProps: { innerHTML: _vm._s(_vm.label) }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-field--row" },
        _vm._l(_vm.uniqueItems, function(item) {
          return _c(
            "div",
            { key: item.id, staticClass: "form-field--input-container" },
            [
              _c(
                "input",
                _vm._b(
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.model,
                        expression: "model"
                      }
                    ],
                    staticClass: "form-field--input",
                    attrs: { type: "radio" },
                    domProps: {
                      value: item.val,
                      checked: _vm._q(_vm.model, item.val)
                    },
                    on: {
                      change: function($event) {
                        _vm.model = item.val
                      }
                    }
                  },
                  "input",
                  _vm.getInputAttrs(item),
                  false
                )
              ),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-field--label-wrap",
                  attrs: { for: item.id }
                },
                [
                  _vm._m(0, true),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "form-field--label",
                    domProps: { innerHTML: _vm._s(item.label) }
                  })
                ]
              )
            ]
          )
        })
      ),
      _vm._v(" "),
      _c("form-field-messages", {
        attrs: { messages: _vm.messages, "active-item": _vm.activeItem }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "form-field--box" }, [
      _c("span", { staticClass: "form-field--box-icon" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36513aa8", { render: render, staticRenderFns: staticRenderFns })
  }
}